import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Mission } from '~/types/mission'

export const useSoftGateStore = defineStore('softGate', () => {
  const showOverlay = ref(false)
  const selectedMission = ref<Mission | null>(null)
  const waitingList = ref(false)

  function toggleOverlay() {
    showOverlay.value = !showOverlay.value
  }

  function hideOverlay() {
    showOverlay.value = false
  }

  function resetSelectedMission() {
    selectedMission.value = null
    waitingList.value = false
  }

  function setWaitingList(value: boolean) {
    waitingList.value = value
  }

  async function closeOverlay() {
    hideOverlay()
    // Wait for fade
    await new Promise((resolve) => setTimeout(resolve, 500))
    resetSelectedMission()
  }

  return {
    showOverlay,
    selectedMission,
    waitingList,
    toggleOverlay,
    hideOverlay,
    resetSelectedMission,
    setWaitingList,
    closeOverlay,
  }
})
